module.exports = __webpack_public_path__ + "img/psy86t8hwqtgcidkrgn1t999hapj8zdbkdhd86bcaee-1972-425c-8692-a594b7b40404.2e441d76.png";